import { __read } from "tslib";
import React, { Fragment } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import styles from './Cursor.module.css';
var POINTER_WIDTH = 12;
var POINTER_HEIGHT = 19;
export default function Cursor(_a) {
    var cursorCoords = _a.cursorCoords, clicks = _a.clicks;
    return (React.createElement(Fragment, null,
        React.createElement(MacPointer, { coords: cursorCoords }),
        clicks.map(function (click) { return (React.createElement(ClickCircle, { coords: click.coords, isMiss: click.isMiss, key: click.id })); })));
}
Cursor.propTypes = {
    cursorCoords: PropTypes.array.isRequired,
    clicks: PropTypes.array.isRequired,
};
function MacPointer(_a) {
    var coords = _a.coords;
    var _b = __read(coords, 2), left = _b[0], top = _b[1];
    return (React.createElement("div", { style: {
            position: 'absolute',
            top: top,
            left: left,
        } },
        React.createElement("svg", { height: POINTER_HEIGHT, width: POINTER_WIDTH },
            React.createElement("g", { fill: "none", fillRule: "nonzero" },
                React.createElement("path", { d: "M0 16.422V.407l11.591 11.619H4.81l-.411.124z", fill: "#FFF" }),
                React.createElement("path", { d: "M9.085 17.096l-3.606 1.535L.798 7.542 4.484 5.99z", fill: "#FFF" }),
                React.createElement("path", { d: "M7.751 16.416l-1.844.773-3.1-7.373 1.841-.776z", fill: "#000" }),
                React.createElement("path", { d: "M1 2.814v11.188l2.969-2.866.428-.139h4.768z", fill: "#000" })))));
}
MacPointer.propTypes = {
    coords: PropTypes.array.isRequired,
};
function ClickCircle(_a) {
    var _b;
    var coords = _a.coords, isMiss = _a.isMiss;
    var _c = __read(coords, 2), left = _c[0], top = _c[1];
    var size = 30;
    return (React.createElement("div", { style: {
            position: 'absolute',
            top: top,
            left: left,
        } },
        React.createElement("div", { className: cx(styles.circle, (_b = {},
                _b[styles.hit] = !isMiss,
                _b[styles.miss] = isMiss,
                _b)), style: {
                width: size,
                height: size,
                top: -size / 2 + POINTER_HEIGHT / 2,
                left: -POINTER_WIDTH,
            } })));
}
ClickCircle.propTypes = {
    coords: PropTypes.array.isRequired,
    isMiss: PropTypes.bool,
};
